
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoYoutubeSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 17"><path fill="#fff" d="M23.475 2.61A2.985 2.985 0 0021.36.495C19.485 0 11.985 0 11.985 0s-7.5 0-9.375.495A2.985 2.985 0 00.495 2.61C0 4.485 0 8.385 0 8.385s0 3.9.495 5.775a2.985 2.985 0 002.115 2.115c1.875.495 9.375.495 9.375.495s7.5 0 9.375-.495a2.985 2.985 0 002.115-2.115c.495-1.875.495-5.775.495-5.775s0-3.9-.495-5.775zM9.57 11.985v-7.2l6.24 3.6-6.24 3.6z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoYoutubeSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
